<template>
  <div id="gallery">
    <div id="previews" :class="{ desktop: !mobile, mobile: mobile }">
      <div class="gallery_link"
        v-if="!selected_gallery"
        @click="selectedGallery('children')">
        <img class="preview main" :src="children_gallery[0]">
        <h3>Children</h3>
      </div>
      <div class="gallery_link"
        v-if="!selected_gallery"
        @click="selectedGallery('hs_seniors')">
        <img class="preview" :src="hs_seniors_gallery[0]">
        <h3>High School Seniors</h3>
      </div>
      <div class="gallery_link"
        v-if="!selected_gallery"
        @click="selectedGallery('pets')">
        <img class="preview" :src="pets_gallery[0]">
        <h3>Pets</h3>
      </div>
      <div class="gallery_link"
        v-if="!selected_gallery"
        @click="selectedGallery('events')">
        <div class="preview_wrapper">
          <img class="preview" :src="events_gallery[0]" width="100">
        </div>
        <h3>Special Events</h3>
      </div>
      <div v-if="selected_gallery" key="gallery">
        <div class="back-button" @click="resetGallery()">
          <i class="fas fa-arrow-left"></i>
        </div>
        <p v-if="mobile"><small><i>Swipe to view different images</i></small></p>
        <div class="imageSlider"
             @mouseover="stopRotation"
             @mouseout="startRotation">
          <div class="slider-arrow" v-if="!mobile">
            <div class="slider-button left" @click="prev">
              <i class="fas fa-angle-left"></i>
            </div>
          </div>
          <v-touch v-on:swipeleft="prev" v-on:swiperight="next">
            <div class="img-wrapper">
              <transition :name="animation" mode="out-in" @after-enter="afterSlide">
                <img :src="currentImage"
                    :key="currentNumber">
              </transition>
            </div>
          </v-touch>
          <div class="slider-arrow" v-if="!mobile">
            <div class="slider-button right" @click="next">
              <i class="fas fa-angle-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gallery',
  data () {
    return {
      selected_gallery: null,
      currentNumber: 0,
      animation: 'fade',
      children_gallery: [
        require('../assets/children_gallery/img_1.jpg'),
        require('../assets/children_gallery/img_2.jpg'),
        require('../assets/children_gallery/img_3.jpg'),
        require('../assets/children_gallery/img_4.jpg'),
        require('../assets/children_gallery/img_5.jpg'),
        require('../assets/children_gallery/img_6.jpg'),
        require('../assets/children_gallery/img_7.jpg'),
        require('../assets/children_gallery/img_8.jpg'),
        require('../assets/children_gallery/img_9.jpg'),
        require('../assets/children_gallery/img_10.jpg'),
        require('../assets/children_gallery/img_11.jpg'),
        require('../assets/children_gallery/img_12.jpg'),
        require('../assets/children_gallery/img_13.jpg'),
        require('../assets/children_gallery/img_14.jpg'),
        require('../assets/children_gallery/img_15.jpg'),
        require('../assets/children_gallery/img_16.jpg')
      ],
      hs_seniors_gallery: [
        require('../assets/hs_seniors_gallery/img_1.jpg'),
        require('../assets/hs_seniors_gallery/img_2.jpg'),
        require('../assets/hs_seniors_gallery/img_3.jpg'),
        require('../assets/hs_seniors_gallery/img_4.jpg'),
        require('../assets/hs_seniors_gallery/img_5.jpg'),
        require('../assets/hs_seniors_gallery/img_6.jpg'),
        require('../assets/hs_seniors_gallery/img_7.jpg'),
        require('../assets/hs_seniors_gallery/img_8.jpg'),
        require('../assets/hs_seniors_gallery/img_9.jpg'),
        require('../assets/hs_seniors_gallery/img_10.jpg'),
        require('../assets/hs_seniors_gallery/img_11.jpg'),
        require('../assets/hs_seniors_gallery/img_12.jpg'),
        require('../assets/hs_seniors_gallery/img_13.jpg'),
        require('../assets/hs_seniors_gallery/img_14.jpg'),
        require('../assets/hs_seniors_gallery/img_15.jpg')
      ],
      pets_gallery: [
        require('../assets/pets_gallery/img_1.jpg'),
        require('../assets/pets_gallery/img_2.jpg'),
        require('../assets/pets_gallery/img_3.jpg'),
        require('../assets/pets_gallery/img_4.jpg'),
        require('../assets/pets_gallery/img_5.jpg'),
        require('../assets/pets_gallery/img_6.jpg'),
        require('../assets/pets_gallery/img_7.jpg'),
        require('../assets/pets_gallery/img_8.jpg'),
        require('../assets/pets_gallery/img_9.jpg'),
        require('../assets/pets_gallery/img_10.jpg')
      ],
      events_gallery: [
        require('../assets/events_gallery/img_1.jpg'),
        require('../assets/events_gallery/img_2.jpg'),
        require('../assets/events_gallery/img_3.jpg'),
        require('../assets/events_gallery/img_4.jpg'),
        require('../assets/events_gallery/img_5.jpg'),
        require('../assets/events_gallery/img_6.jpg'),
        require('../assets/events_gallery/img_7.jpg'),
        require('../assets/events_gallery/img_8.jpg'),
        require('../assets/events_gallery/img_9.jpg'),
        require('../assets/events_gallery/img_10.jpg'),
        require('../assets/events_gallery/img_11.jpg'),
        require('../assets/events_gallery/img_12.jpg'),
        require('../assets/events_gallery/img_13.jpg'),
        require('../assets/events_gallery/img_14.jpg'),
        require('../assets/events_gallery/img_15.jpg'),
        require('../assets/events_gallery/img_16.jpg'),
        require('../assets/events_gallery/img_17.jpg'),
        require('../assets/events_gallery/img_18.jpg'),
        require('../assets/events_gallery/img_19.jpg')
      ],
      mobile: false
    }
  },

  created () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.mobile = true
    }
  },

  methods: {
    selectedGallery (selection) {
      if (!this.mobile) {
        this.selected_gallery = this[selection + '_gallery']
      } else {
        this.selected_gallery = this[selection + '_gallery'].slice().reverse()
        this.currentNumber = this.selected_gallery.length - 1
      }
    },

    resetGallery: function () {
      this.selected_gallery = null
      this.currentNumber = 0
    },

    startRotation: function () {
      this.timer = setInterval(this.next, 8000)
    },

    stopRotation: function () {
      clearTimeout(this.timer)
      this.timer = null
    },

    next: function () {
      this.currentNumber += 1
    },

    prev: function () {
      this.animation = 'fade-reverse'
      if (this.currentNumber === 0) {
        this.currentNumber = this.selected_gallery.length - 1
      } else {
        this.currentNumber -= 1
      }
    },

    afterSlide: function () {
      this.animation = 'fade'
    }
  },

  computed: {
    currentImage: function () {
      return this.selected_gallery[Math.abs(this.currentNumber) % this.selected_gallery.length]
    }
  }
}
</script>

<style scoped>
#previews.desktop {
  display: flex;
  justify-content: space-between;
}

.preview {
  object-fit: cover;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

#previews.desktop .gallery_link:hover {
  cursor: pointer;
}

#previews.desktop .gallery_link:hover .preview {
  width: 125px;
  height: 125px;
}

#previews.mobile .preview {
  margin-top: 30px;
}

#gallery_view {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

#gallery_view .preview {
  margin: 25px;
}

#previews.desktop img {
  max-width: 600px;
  max-height: 600px;
  transition: all 0.8s;
}

#previews.mobile img {
  max-width: 95vw;
  transition: all 0.8s;
}

.imageSlider {
  height: 550px;
}

#previews.desktop .imageSlider {
  width: auto;
  display: flex;
  justify-content: space-between;
  margin-left: 25px;
}

#previews.mobile .imageSlider {
  overflow: hidden;
}

.slider-arrow {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.slider-button {
  padding: 10px 5px 10px 5px;
  border-radius: 5px;
  font-size: 24px;
  color: #00a7af;
  transition: all 0.5s;
}

.slider-button.left {
  margin-right: 50px;
}

.slider-button.right {
  margin-left: 50px;
}

.slider-button:hover {
  color: white;
  background-color: #575f60;
  cursor: pointer;
}

#previews.desktop .back-button {
  text-align: left;
  font-size: 20px;
  color: #00a7af;
  max-width: 25px;
  border-radius: 5px;
  padding: 5px;
}

#previews.mobile .back-button {
  text-align: left;
  font-size: 32px;
  color: #00a7af;
  max-width: 25px;
  border-radius: 5px;
  padding: 20px;
}

.back-button:hover {
  cursor: pointer;
  color: white;
  background-color: #575f60;
}

.selected_gallery {
  text-align: left;
}

#previews.desktop .img-wrapper {
  min-width: 600px;
  height: 600px;
}

.fade-transition {
  transition: all 1s ease;
  visibility: visible;
  overflow: hidden;
  opacity: 1;
  position: absolute;
}

.fade-enter-active{
  opacity: 0;
  transform: translate(-100%, 0);
}

.fade-leave-active{
  opacity: 0;
  transform: translate(100%, 0);
}

.fade-reverse-transition {
  transition: all 1s ease;
  visibility: visible;
  overflow: hidden;
  opacity: 1;
  position: absolute;
}

.fade-reverse-enter-active{
  opacity: 0;
  transform: translate(100%, 0);
}

.fade-reverse-leave-active{
  opacity: 0;
  transform: translate(-100%, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue